import { Icon } from '@ferris/react';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { Card, CardContent } from '@ferris/react/components/cards';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { createInteractionEvent } from '../../../utils/EventProviders/EgClickstreamUtil';

export const ReadyToList = (props) => {
    const {
        headline,
        subheadline,
        buttonText,
        buttonLink,
        footer1,
        footer2,
        footer3,
        isFrboFlow,
        loginPrompt
    } = props;
    const { trigger } = useContext(TrackingContext);
    const triggerClickstream = (eventName, actionLocation = '', useTenant = false, eventVersion = '1.0.0') => {
        trigger('interaction', createInteractionEvent(`${eventName}.selected`, 'Property Onboarding', '', actionLocation, useTenant, eventVersion));
        return true;
    };

    const footer2ToUse = { text: footer2.text, url: footer2.url || '/onboarding/addProperty' };
    const loginBtn = isFrboFlow ? footer3 : footer2ToUse;

    return (
        <section className={cn('ulx__aem-section', 'pm-intake-section')}>
            {
                isFrboFlow && (
                    <Card
                        elevation="16"
                        theme="default"
                        classes={cn('form')}
                    >
                        <CardContent
                            classes={cn('form-content')}
                        >
                            <h2>{headline}</h2>
                            <p>{subheadline}</p>
                            <a
                                href={buttonLink !== 'rtl_link_cta1_list' ? buttonLink : '#'}
                                onClick={() => (isFrboFlow
                                    ? triggerClickstream('property_manager', '')
                                    : triggerClickstream('list_your_property', 'bottom', true, '2.3.0'))
                                }
                            >
                                <span
                                    className="fds-button fds-button-primary learn-more-cta "
                                >
                                    <div className="fds-button-label">{buttonText}</div>
                                    <Icon
                                        name="open-in-new"
                                    />
                                </span>
                            </a>
                        </CardContent>
                    </Card>
                )
            }
            <Card
                elevation="16"
                theme="default"
                classes={cn('form')}
            >
                <CardContent
                    classes={cn('form-content')}
                >
                    <h2>{footer1}</h2>
                    <p>{loginPrompt}</p>
                    <a
                        href={loginBtn.url}
                        onClick={() => triggerClickstream('login', '', true, '2.3.0')}
                    >
                        <span
                            className="fds-button fds-button-primary learn-more-cta"
                        >
                            <div className="fds-button-label">{loginBtn.text}</div>
                            <Icon
                                name="open-in-new"
                            />
                        </span>
                    </a>
                </CardContent>
            </Card>
        </section>
    );
};

ReadyToList.propTypes = {
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonLink: PropTypes.string.isRequired,
    footer1: PropTypes.string.isRequired,
    footer2: PropTypes.shape({
        url: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    }).isRequired,
    footer3: PropTypes.shape({
        url: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    }).isRequired,
    isFrboFlow: PropTypes.bool.isRequired,
    loginPrompt: PropTypes.string.isRequired
};

export default ReadyToList;
